import store from './state';


const actions = {
  ...store.actions,
};
export {
  actions,
};
